/**
 * External Dependencies
 */
// import 'bootstrap'
import 'materialize-css/js/global'
import 'materialize-css/js/cash'
import 'materialize-css/js/forms'
import 'smartwizard'
import 'moment'

 $(document).ready(function () {
  // write your js codes here
  // console.log('test');

    if ( $('#smartwizard').length > 0 ) {
        if ( !$('#smartwizard').hasClass('tech_resubmission_form_body') ) {
            $('#smartwizard').smartWizard({
                theme: 'progress',
                autoAdjustHeight: false,
                enableURLhash: false,  
                lang: { // Language variables for button
                    next: 'Next',
                    previous: 'Back',
                },
                justified: true,
                anchorSettings: {
                    removeDoneStepOnNavigateBack: true, // While navigate back done step after active step will be cleared
                },
                keyboardSettings: {
                    keyNavigation: false, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
                }
            })
        }
        
    }

    $('.toolbar-bottom').removeAttr('style')
    var firstname = $('#firstname').val()
    var middlename = $('#middlename').val()
    var lastname = $('#lastname').val()
    var birthdate = $('#birthdate').val()
    var email = $('#email').val()
    var mobile = $('#mobile').val()
    var house_number = $('#house_number').val()
    var street = $('#street').val()
    var barangay = $('#barangay').val()
    var city = $('#city').val()

    var employment = $('input[name="employment"]:checked').val()
    var technician_expertise = $('#technician_expertise').val()
    var equipment_expertise = $('#equipment_expertise').val()
    var service_type = $('#service_type').val()
    var years_experience = $('#years_experience').val()
    var service_cities = $('input[name="radioServiceCity"]:checked').val()
    var service_areas = $('#service_areas').val()
    var transportation_mode = $('#transportation_mode').val()
    var tools = $('input[name="tools"]:checked').val()

    var valid_certificates = $('#valid_certificates').val()
    var government_id = $('#government_id').val()

    var data = [firstname, middlename, lastname, birthdate, email, mobile, house_number, street, barangay, city ,employment, technician_expertise, equipment_expertise, service_type, years_experience, service_cities, service_areas, transportation_mode, tools ,valid_certificates, government_id]
    
    $("#smartwizard").on("leaveStep", function ( e, anchorObject, currentStepIndex, nextStepIndex, stepDirection ) {
        let errors = 0

        if (stepDirection === 'forward') {
            if (currentStepIndex === 0) {
                
                var errorMsg = 'Please match the requested format.';
                $('input[type="text"]:not(.form-input-optional)').each(function() {
                    var parentId = $(this).parents('.tab-pane').attr('id');
                    var patternAttr = $(this).attr('pattern');
                    var id = $(this).attr('id');
                    var val = $(this).val();
                    var pattern = null;
                    $('.'+id).find('.form-error').remove();
                    $(this).removeClass('has-error');
                    if (parentId == 'step-1') {
                        if (!val) {
                            errors++; 
                            $(this).addClass('has-error');
                        } else {
                            if (typeof patternAttr !== 'undefined') {
                                pattern = new RegExp(patternAttr)
                                if (!pattern.test(val)) {
                                    errors++;
                                    $('.'+id).append('<span class="form-error">' + errorMsg + '</span>');
                                    $(this).addClass('has-error');
                                } else {
                                    $(this).removeClass('has-error');
                                }
                            } else {
                                $(this).removeClass('has-error');
                                if (id === 'dob') {
                                    $('.'+id).find('.form-error').remove();
                                    var age = _calculateAge(val);
                                    var bool = moment(val, 'MM/DD/YYYY',true).isValid();
                                    if (!age) {
                                        errors++;
                                        $('.'+id).append('<span class="form-error">Sorry we accept 18yrs above.</span>');
                                        $(this).addClass('has-error');
                                    }

                                    if (!bool) {
                                        errors++;
                                        $('.'+id).append('<span class="form-error">Invalid Date format</span>');
                                        $(this).addClass('has-error');
                                    }
                                }
                            }
                        }
                    }
                });

            } else if (currentStepIndex === 1) {

                $('input[type="radio"]').each(function() {
                    var parentId = $(this).parents('.tab-pane').attr('id');
                    var id = $(this).parents('.flex').attr('id');
                    var name = $(this).attr('name');
                    $('.'+id).find('.form-error').remove();
                    $(this).removeClass('has-error');
                    if (parentId == 'step-2') {
                        if ($('input[name="'+name+'"]:checked').length > 0) {
                            $('.'+id).find('.radio-mark').removeClass('has-error');
                        } else {
                            errors++;
                            $('.'+id).find('.radio-mark').addClass('has-error');
                        }
                    }
                });

                var errorMsg = 'Please match the requested format.';
                $('input[type="text"]').each(function() {
                    if (!$(this).hasClass('chosen-search-input')) {
                        var parentId = $(this).parents('.tab-pane').attr('id');
                        if (parentId == 'step-2') {
                            var patternAttr = $(this).attr('pattern');
                            var id = $(this).attr('id');
                            var val = $('#'+id).val();
                            var pattern = null;
                            $('.'+id).find('.form-error').remove();
                            $(this).removeClass('has-error');
                            if (val == '') {
                                errors++; 
                                $(this).addClass('has-error');
                            } else {
                                if (typeof patternAttr !== 'undefined') {
                                    pattern = new RegExp(patternAttr)
                                    if (!pattern.test(val)) {
                                        errors++;
                                        $('.'+id).append('<span class="form-error">' + errorMsg + '</span>');
                                        $(this).addClass('has-error');
                                    } else {
                                        $(this).removeClass('has-error');
                                    }
                                } else {
                                    $(this).removeClass('has-error');
                                }
                            }
                        }
                    }
                });

                $('select').each(function() {
                    var parentId = $(this).parents('.tab-pane').attr('id');
                    var id = $(this).attr('id');
                    $('.'+id).find('.form-error').remove();
                    $(this).removeClass('has-error');
                    if (parentId == 'step-2') {
                        if (!$('#'+id).val()) {
                            errors++;
                            $('#'+id+'_chosen').addClass('has-error');
                            
                            $(this).addClass('has-error');
                        } else {
                            $('#'+id+'_chosen').removeClass('has-error');

                            $(this).removeClass('has-error');
                        }
                    }
                    
                });
                
            }

            if (errors > 0) {

                if (!$('.form-error')[0]) {
                    var danger = $('<div class="form-error align-right mr-4" />').html('Please complete the required fields.');
                    danger.insertBefore('.toolbar-bottom');
                }

                e.preventDefault();
            } else {
                // e.preventDefault();

                $('div').remove('.form-error');
            }

        }
    });

    $("#smartwizard").on("stepContent", function(e, anchorObject, stepIndex, stepDirection) {
        var next = 'sw-btn-next';
        if (stepIndex === 2) {
            setTimeout(function() {
                $('.'+next).removeClass('disabled').html('Submit').attr('type','submit');
                $('.'+next).addClass('wizard-submit');
            })

        } else {
            setTimeout(function() {
                $('.sw-btn-next').removeClass('wizard-submit').html('Next').attr('type','button');
            })
        }
    })

    function _calculateAge(dob) {
        var dateNow = new Date()
        var birthday = new Date(dob)
        var age = dateNow.getFullYear() - birthday.getFullYear();
        var birthMonthDay = new Date(dateNow.getFullYear(), birthday.getMonth(), birthday.getDate(), dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds()); 

        if (dateNow < birthMonthDay) {
            age--;
        }
        
        if (age < 18) {
            return false;
        }

        return true;
    }

    $(document).on('click','input[type="radio"]', function() {
        var id = $(this).parents('.flex').attr('id');
        var name = $(this).attr('name');

        if ($('input[name="'+name+'"]:checked').length > 0) {
            $('.'+id).find('.radio-mark').removeClass('has-error');
        }
    })

    $(document).on('click','.wizard-submit', function(e) {
        e.preventDefault();
        var f = $('.join-as-tech');
        var b = f.find('button[type=submit]');
        var t = b.text();
        let errors = 0;

        var files = [];

        $('.form-error').remove();

        $('.tech-dropzone:visible').not('.tech-dropzone-optional').each(function () {
            var count = $(this).find(".dz-preview.dz-success").length;
            
            if(count < 1) {
                $(this).addClass('has-error');
    
                errors++;
            } else {
                $(this).removeClass('has-error');
            }
        });
    
        $('.tech-dropzone:visible').find(".dz-preview.dz-success").each(function () {
            files.push($(this).data('file'));
        })

        $('.img-file').each(function(){
            files.push($(this).data('file'));
        });

        if (files.length > 0) {
            $('input[name="files"]').val(JSON.stringify(files));
        }

        $('select').each(function() {
            var parentId = $(this).parents('.tab-pane').attr('id');
            var id = $(this).attr('id');
            if (parentId == 'step-3') {
                if (!$('#'+id).val()) {
                    errors++;
                    $('#'+id+'_chosen').addClass('has-error');
                } else {
                    $('#'+id+'_chosen').removeClass('has-error');
                }
            }
            
        });

        if (errors > 0) return false;

        var formData = new FormData(f[0]);

        $.ajax({
            type: f.attr('method'),
            url: f.attr('action'),
            data: formData,
            dataType: 'json',
            async: true,
            cache: false,
            contentType:false,
            processData:false,
            beforeSend: function() {

                if (b.hasClass('disabled')) return false;
        
                if (f.find('.loader')) {
                    f.find('.loader').removeClass('hide');
                }

                b.attr('disabled', true);
                b.addClass('btn-disabled', true);

                b.text('Loading...');
                
                if ($('div').hasClass('alert-error')) {
                    $('.alert-error').fadeOut();
                }
                if ($('div').hasClass('alert-success')) {
                    $('.alert-success').fadeOut();
                }
                if ($('span').hasClass('form-error')) {
                    $('.form-error').fadeOut();
                }
            },
            success: function(result) {
                if (result.success == true) {

                    if (result.action == 'redirect') {

                        if (!empty(result.text)) {
                            var danger = $('<div class="form-success align-right mr-4" />').html(result.text);
                            danger.insertBefore('.toolbar-bottom');
                        }

                        if (typeof result.slow != 'undefined') {
                            setTimeout(function() {
                                window.location = result.url;
                            }, 2500);
                        } else {
                            setTimeout(function() {
                                window.location = result.url;
                            }, 1000);
                        }
                    }

                } else {
                    b.removeAttr('disabled');
                    b.removeClass('btn-disabled').text(t);
                 
                    if (!empty(result.text.data)) {
                        $.each(result.text.data, function(key, data){
                            var id = data.attr_class.replace('#','');
                            var stepId = $(data.attr_class).parents('.tab-pane').data('sequence');
                            $(data.attr_class).parents('.'+id).append('<span class="form-error">' + data.message + '</span>');
                            $('#smartwizard').smartWizard("goToStep", stepId);
                        });
                    } else {
                        if (!empty(result.text)) {
                            var danger = $('<div class="form-error align-right mr-4" />').html(result.text);
                            danger.insertBefore('.toolbar-bottom');
                        }
                    }
                }

                if (result.action == 'redirect') {
                    if (typeof result.slow != 'undefined') {
                        setTimeout(function() {
                            window.location = result.url;
                        }, 2500);
                    } else {
                        setTimeout(function() {
                            window.location = result.url;
                        }, 1000);
                    }
                }
            },
            complete: function() {
                b.removeAttr('disabled');
                b.removeClass('btn-disabled').text('Submit');
            }
        });

        return false;
    })

    $('#tech_resubmission_form').on('submit', function(e){
        e.preventDefault();
        
        var submitBtn = $(this).find('button[type=submit]');
        var firstname = $('#firstname');
        var middlename = $('#middlename');
        var lastname  = $('#lastname');
        var mobile    = $('#mobile');
        var errors    = 0;

        if (firstname.val().trim().length > 0) {
            $(firstname).removeClass('has-error');
        } else {
            $(firstname).addClass('has-error');
            errors++;
        }

        if (middlename.val().trim().length > 0) {
            $(middlename).removeClass('has-error');
        } else {
            $(middlename).addClass('has-error');
            errors++;
        }

        if (lastname.val().trim().length > 0) {
            $(lastname).removeClass('has-error');
        } else {
            $(lastname).addClass('has-error');
            errors++;
        }

        if (mobile.val().trim().length > 0) {
            $(mobile).removeClass('has-error');
        } else {
            $(mobile).addClass('has-error');
            errors++;
        }

        var files = [];

        $('.tech-dropzone').each(function () {
            var count = $(this).find(".dz-preview.dz-success").length;
            
            if(count < 1) {
                $(this).addClass('has-error');
    
                errors++;
            } else {
                $(this).removeClass('has-error');
            }
        });
    
        $('.tech-dropzone').find(".dz-preview.dz-success").each(function () {
            files.push($(this).data('file'));
        })

        if (files.length > 0) {
            $('input[name="files"]').val(JSON.stringify(files));
        }

        if (errors > 0) return false;

        var formData = new FormData($(this)[0]);

        $.ajax({
            type: $(this).attr('method'),
            url: $(this).attr('action'),
            data: formData,
            dataType: 'json',
            async: true,
            cache: false,
            contentType:false,
            processData:false,
            beforeSend: function() {
                if (submitBtn.hasClass('disabled')) return false;
        
                if (submitBtn.find('.book-spinner')) {
                    submitBtn.find('.book-spinner').removeClass('hide');
                }

                submitBtn.attr('disabled', true);
                submitBtn.addClass('btn-disabled', true);

                submitBtn.find('span').text('Loading...');
                
                if ($('div').hasClass('alert-error')) {
                    $('.alert-error').fadeOut();
                }
                if ($('div').hasClass('alert-success')) {
                    $('.alert-success').fadeOut();
                }
                if ($('span').hasClass('form-error')) {
                    $('.form-error').fadeOut();
                }
            },
            success: function(result) {

                if (result.success == true) {
                    $('#tech_resubmission_form')[0].reset();
                    $('#tech_resubmission_form').find('.dz-preview').remove();
                    
                    if (result.action == 'redirect') {
                        if (!empty(result.text)) {
                            var danger = $('<div class="col-md-12 col-lg-8" />').html('<div class="alert alert-success">'+result.text+'<div>');
                            danger.insertBefore('.firstname');
                        }

                        if (typeof result.slow != 'undefined') {
                            setTimeout(function() {
                                window.location = result.url;
                            }, 2500);
                        } else {
                            setTimeout(function() {
                                window.location = result.url;
                            }, 1000);
                        }
                    }

                } else {
                    submitBtn.find('.book-spinner').addClass('hide');
                    submitBtn.removeAttr('disabled');
                    submitBtn.removeClass('btn-disabled').find('span').text('Submit');
                 
                    if (!empty(result.text.data)) {
                        $.each(result.text.data, function(key, data){
                            var id = data.attr_class.replace('#','');
                            $(data.attr_class).parents('.'+id).append('<span class="form-error">' + data.message + '</span>');
                        });
                    } else {
                        if (!empty(result.text)) {
                            var danger = $('<div class="col-md-12 col-lg-8" />').html('<div class="alert alert-error">'+result.text+'<div>');
                            danger.insertBefore('.firstname');
                        }
                    }
                }
            },
            complete: function() {

                submitBtn.find('.book-spinner').addClass('hide');
                submitBtn.removeAttr('disabled');
                submitBtn.removeClass('btn-disabled').find('span').text('Submit');
            }
        });
     });

     $(document).on('click', '#link_show_gov_id', function(e) {
        e.preventDefault();

        $('.sample-government-id:visible').not($(this).closest('div').find('.sample-government-id')).addClass('hide');
        $('.sample-vac-card').addClass('hide');
        $(this).closest('div').find('.sample-government-id').toggleClass('hide');
    })

    $(document).on('click', '#link_show_cert', function(e) {
        e.preventDefault();

        $('.sample-certificate:visible').not($(this).closest('div').find('.sample-certificate')).addClass('hide');
        $('.sample-vac-card').addClass('hide');
        $(this).closest('div').find('.sample-certificate').toggleClass('hide');
    })

    $('#link_show_vac_card').on('click', function(e) {
        e.preventDefault();

        $('.sample-government-id:visible').addClass('hide');
        $('.sample-certificate:visible').addClass('hide');
        $('.sample-vac-card').toggleClass('hide');
    })

    $('#request_demo_form').on('submit', function(event) {
        event.preventDefault();

        var submitButton = $("button[type=submit]", this); 
        submitButton.attr('disabled', true);
        submitButton.addClass('btn-disabled', true);
        
        $('.form-error').filter(':visible').addClass('d-none');

        //form data

        let data = {}
        $.map($(this).serializeArray(), function(o, i) { data[o['name']] = o['value'] })

            $.ajax ({
            url: base_url+'/request-a-demo?utm=tekopro',
            type: 'POST',
            dataType: 'json',
            data: $(this).serialize(),
            success: function(result) {

                if (result.success == false) {

                    submitButton.attr('disabled', false);
                    submitButton.removeClass('btn-disabled', true);

                    if (!IsEmpty(result.text.data)) {
                        $.each(result.text.data, function(key, data) {
                            $(data.attr_class).parents('.form-parent').find('.error_message_' + data.key).html(data.message);
                            $(data.attr_class).parents('.form-parent').find('.error_message_' + data.key).removeClass('d-none');
                        });
                    }
                } else {
                    $('#form_success').show()
                    $('#form_paper').hide()
                }
                    // console.log('success');
            }
        })

    })
})